import { ButtonProperties } from "../../control/properties/ButtonProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { PromptDialog } from "../display/PromptDialog";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractMessageDialogProperties } from "./AbstractMessageDialogProperties";
/**
 * AbstractPromptDialogProperties.ts
 */
export class AbstractPromptDialogProperties extends AbstractMessageDialogProperties {
    equals(other) {
        return super.equals(other) &&
            this.cancelButtonProperties.equals(other.cancelButtonProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.confirmButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE);
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0);
        this.cancelButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_0, CommonStyle.MODULE);
        this.cancelButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_0);
    }
    getClass() {
        return PromptDialog;
    }
    getClassName() {
        return "PromptDialog";
    }
}
//# sourceMappingURL=AbstractPromptDialogProperties.js.map